import { Box } from '@mui/material';
import React from 'react';
import Plot from 'react-plotly.js';
import { basePlotConfig, useChartTheme } from '../overview/plotTheme';

const DailyPlot = ({
  tsCharge,
  tsDischarge,
  tsTemperatureMin,
  tsTemperatureMax,
}) => {
  const { colors, baseLayout: makeLayout, themeTrace } = useChartTheme();
  const baseLayout = makeLayout("Energy (kWh)");

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Plot
        data={[
          tsCharge,
          tsDischarge,
          tsTemperatureMin,
          tsTemperatureMax,
        ].map(themeTrace)}
        layout={{
          ...baseLayout,
          legend: { ...baseLayout.legend, x: 0, xanchor: "left" },
          yaxis2: {
            title: { text: "Ambient temp. (°C)", font: { size: 12, color: colors.text }, standoff: 8 },
            overlaying: "y",
            side: "right",
            zeroline: false, // Avoid a second zero line when the two axes scale differently
            showgrid: false,
            automargin: true,
          },
        }}
        config={basePlotConfig}
        useResizeHandler={true}
        style={{ width: "100%", height: "100%" }}
      />
    </Box>
  )
}

export default DailyPlot;
